/** 与后端 print_models.PRINT_SCENARIO_LABELS 保持一致 */
export const PRINT_SCENARIO_PRESETS = [
  { value: '', label: '通用' },
  { value: 'standard', label: '标准出库' },
  { value: 'warehouse_pick', label: '仓库拣货' },
  { value: 'customer_copy', label: '客户联' },
  { value: 'finance', label: '财务留存' },
  { value: 'logistics', label: '物流交接' },
  { value: 'dispatch_branch_label', label: '分码标签' }
]

export function labelForScenario (key) {
  const k = key == null ? '' : String(key)
  const hit = PRINT_SCENARIO_PRESETS.find((p) => p.value === k)
  if (hit) return hit.label
  return k || '通用'
}
